// Generated by scripts/v2/deploy.js. Do not edit by hand.
export const NETWORK_NAME = "work";
export const CHAIN_ID = 56;
export const PROTOCOL_HASH = "0xcb7a698ee0056ebe9981231476479bddb069a9c39d20efa0969f30ba7e88b40d";
export const AMOUNT_DECIMALS = 18;

export const MINI_PAY_WALLET_FACTORY = "0xE0bA703b7dAebC2F9A9259c1F2AfD6d0FE3e5C15";
export const RANK_V2 = "0xB9d45054D4ff97637b1793EdD371Dbb739f4B903";
export const MA_V2 = "0xa2F9782Bb1106146eD6BA502333Aa7Fa8200f7a7";
export const BUY_CVC = "0xB1A25c1BF7Affdb4608E1AaF37A4a5cb991E0f8f";
export const REWARD_CONTROLLER = "0x2F08d17fc5fBbab6021deAF97c1Cee47bd3E9799";
export const CVCD_SWAP = "0x42cF5c82FdFc17022f9dE02A1B0d34323177d75A";

export const CVC = "0xB45e6Dd851df10961D1aAD912BaF220168FCAA25";
export const CVCD = "0xBA12E794a3d9dbe504b424a80C08af0aCeB50b81";
export const USDT = "0x55d398326f99059fF775485246999027B3197955";
export const USDT_CVC_LP = "0xCA300f8115413051202111E82C99A06916cE8d5a";

export const V2_CONTRACTS = {
  MINI_PAY_WALLET_FACTORY: MINI_PAY_WALLET_FACTORY,
  RANK_V2: RANK_V2,
  MA_V2: MA_V2,
  BUY_CVC: BUY_CVC,
  REWARD_CONTROLLER: REWARD_CONTROLLER,
  CVCD_SWAP: CVCD_SWAP,
};

export const V2_TOKENS = {
  CVC: CVC,
  CVCD: CVCD,
  USDT: USDT,
  USDT_CVC_LP: USDT_CVC_LP,
};
